<script>
  import {getContext} from 'svelte';
  import {PATTERNS} from '@/const/patterns';
  import lang from '../RegisterPage.lang';

  export let password = null;
  export let isPasswordTips = false;
  export let placement = 'left';
  export let isShowSpecialCharacters = 5;

  const LG = getContext('LG');

  let validateMap = [
    {
      text: LG(lang.OrMoreCharacters),
      status: false,
      rule: (password) => password.length >= 8,
    },
    {
      text: LG(lang.LowercaseLetter),
      status: false,
      rule: (password) => /[a-z]/.test(password),
    },
    {
      text: LG(lang.UppercaseLetter),
      status: false,
      rule: (password) => /[A-Z]/.test(password),
    },
    {
      text: LG(lang.ContainsNumber),
      status: false,
      rule: (password) => /\d/.test(password),
    },
    {
      text: LG(lang.ContainsSpecialCharacters),
      status: false,
      rule: (password) => PATTERNS.CHARACTER_ASC.test(password),
    },
  ];

  $: updateValidatePassword(password);

  function updateValidatePassword(password) {
    if (password === null && !password) {
      return null;
    }
    validateMap.forEach((item) => {
      item.status = item.rule(password);
    });
    validateMap = [...validateMap];
  }
</script>

<style>
  .wrap {
    border-radius: 2px;
    padding: 16px 20px;
    min-width: 200px;
    background: #fff;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  }
  .before {
    position: absolute;
    top: 13px;
    left: -13px;
    display: block;
    border: 7px;
    border-style: dashed dashed solid dashed;
    border-color: transparent #fff transparent transparent;
    width: 0;
    height: 0;
    content: '';
  }
  .right .before {
    display: none;
  }
  @media screen and (max-width: 640px) {
    .wrap {
      padding: 8px 12px;
      box-shadow: none;
    }
    .before {
      display: none;
    }
  }
</style>

<div class="wrap pr df fdc T3" class:right={placement === 'right'}>
  <i class="before" />
  <div>{LG(lang.YourPasswordShould)}</div>
  {#each validateMap as item, index}
    {#if index < isShowSpecialCharacters}
      <div class="df mt10" class:sell={isPasswordTips && !item.status}>
        {#if item.status}
          <i class="iconfont mr10 BLUE">&#xe801;</i>
        {:else}
          <i class="iconfont mr10 T4">&#xe622;</i>
        {/if}
        {item.text}
      </div>
    {/if}
  {/each}
</div>
